import { render, staticRenderFns } from "./ActivateOtherSupplier.vue?vue&type=template&id=4595abae&scoped=true"
import script from "./ActivateOtherSupplier.vue?vue&type=script&lang=js"
export * from "./ActivateOtherSupplier.vue?vue&type=script&lang=js"
import style0 from "./ActivateOtherSupplier.vue?vue&type=style&index=0&id=4595abae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595abae",
  null
  
)

export default component.exports